import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { useConnectedUser } from "../hooks/user.hooks";
import { useCallback, useEffect } from "react";
import { getToken } from "../client";
import { fetchMe } from "../queries/user.queries";
import { Box, useDisclosure } from "@chakra-ui/react";
import InviteUserModal from "../components/modals/InviteUserModal";
import InvitationSentModal from "../components/modals/InvitationSentModal";
import { useMutation } from "react-query";
import { markAsVisited } from "../mutations/center.mutations";
import { User } from "../types/user.types";
import { useMediaQuery } from "@uidotdev/usehooks";
import SidebarMobile from "../components/SidebarMobile";
import { useCenters } from "../hooks/centers.hooks";

function RootPage() {
	const user = useConnectedUser();
	const navigate = useNavigate();
	const { isOpen, onOpen, onClose } = useDisclosure();
	const {
		isOpen: sentIsOpen,
		onOpen: sentOnOpen,
		onClose: sentOnClose,
	} = useDisclosure();

	const handleInvitationSent = useCallback(
		(users: Partial<User>[]) => {
			onClose();
			if (users.length > 0) {
				sentOnOpen();
			}
		},
		[onClose, sentOnOpen],
	);
	useEffect(() => {
		if (!user) {
			getToken();
			fetchMe().catch(() => {
				navigate("/login");
			});
		}
	}, [navigate, user]);
	const { center } = useCenters();
	const { mutate: mutateMarkAsVisited } = useMutation(markAsVisited);
	useEffect(() => {
		if (
			center &&
			center.access === "ADMIN" &&
			(center.firstConnection === null || center.firstConnection === undefined)
		) {
			onOpen();
			mutateMarkAsVisited({ center: center });
		}
	}, [center, onOpen, mutateMarkAsVisited]);
	const isSmallDevice = useMediaQuery("only screen and (max-width : 768px)");

	if (isSmallDevice) {
		return (
			<Box>
				<SidebarMobile />
				<Box px="16px">
					<Outlet />
				</Box>
			</Box>
		);
	}
	return (
		<Box p={0} m={0}>
			<Sidebar />
			<Box bg="zinc.50" minHeight={"100vh"} width="100%">
				<Box
					bg="white"
					roundedLeft="40px"
					py="48px"
					px="32px"
					border="solid 1px"
					borderColor="gray.200"
					position={"relative"}
					left="290px"
					width={"calc(100vw - 290px)"}
					top={4}
				>
					{center !== undefined && <Outlet />}
				</Box>
			</Box>

			<InviteUserModal
				isOpen={isOpen}
				onClose={handleInvitationSent}
				onOpen={onOpen}
			></InviteUserModal>
			<InvitationSentModal
				isOpen={sentIsOpen}
				onClose={sentOnClose}
				onOpen={sentOnOpen}
			></InvitationSentModal>
		</Box>
	);
}

export default RootPage;
